import React, { useEffect } from "react"
import { useSearchParams, Link } from "react-router-dom"
import { Container, Row, Col, Card, CardBody, Button, Badge, Alert } from "reactstrap"

/**
 * Ek modül ödemesinin başarısız dönüşü.
 *
 * <p>Burada durum ucu yoklanmaz: PayTR kullanıcıyı bu adrese yalnız işlem
 * başarısız olduğunda gönderir ve kaydı {@code CANCELLED} yapan callback
 * sunucu tarafında işler. Yoklamak, kullanıcıya zaten bilinen bir sonucu
 * beklettirmekten başka bir şey yapmazdı.
 */
const AddonPaymentFail = () => {
  const [searchParams] = useSearchParams()
  const merchantOid = searchParams.get("merchant_oid") || ""

  useEffect(() => {
    document.title = "Ek Modül Ödemesi Başarısız - Tahsilat360"
  }, [])

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{ background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)" }}>
      <Container className="px-3 px-sm-0">
        <Row className="justify-content-center">
          <Col lg={6} md={8} sm={10}>
            <Card className="border-0 shadow-lg" style={{ borderRadius: 20, overflow: "hidden" }}>
              <CardBody className="text-center p-4 p-sm-5">
                <div className="d-flex align-items-center justify-content-center mb-4 mx-auto" style={{
                  width: 100, height: 100, borderRadius: "50%",
                  background: "linear-gradient(135deg, #f44336, #d32f2f)",
                  boxShadow: "0 10px 30px rgba(244,67,54,.3)",
                }}>
                  <i className="bx bx-x text-white" style={{ fontSize: 48 }} />
                </div>

                <Alert color="danger" className="border-0 mb-4">
                  <h4 className="alert-heading mb-1">Ödeme Başarısız</h4>
                  <p className="mb-0">Ek modül satın alma işlemi tamamlanamadı.</p>
                </Alert>

                <p className="text-muted mb-4" style={{ fontSize: 15, lineHeight: 1.6 }}>
                  Kartınızdan tutar çekilmediyse yeniden deneyebilirsiniz. Sorun sürerse
                  bankanızla veya destek ekibimizle iletişime geçin.
                </p>

                {merchantOid && (
                  <div className="mb-4">
                    <label className="form-label text-muted small mb-1 d-block">İşlem Numarası</label>
                    <Badge color="danger" className="px-3 py-2"
                      style={{ fontSize: 14, fontFamily: "'Courier New', monospace" }}>
                      {merchantOid}
                    </Badge>
                  </div>
                )}

                <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center">
                  <Link to="/subscription/addons">
                    <Button color="primary" className="px-4 py-2" style={{ fontWeight: 600 }}>
                      <i className="bx bx-refresh me-2" />Tekrar Dene
                    </Button>
                  </Link>
                  <Link to="/dashboard">
                    <Button color="light" className="px-4 py-2">
                      <i className="bx bx-home me-2" />Kontrol Paneli
                    </Button>
                  </Link>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AddonPaymentFail
